module.exports = __webpack_public_path__ + "media/images/crypto/bcc_small-9fa19417605c368ff3299b8ddaea023a.png";